module.exports = __webpack_public_path__ + "static/apple-touch-icon-152x152-2dbb411bcc9a4392360ce793486d119a.png";